import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const NotFoundCheckDetailSource = {
  // Legacy, delete later
  fetchFullCheck: function() {
    return axios.get(`${API_BASE}/broken_links/check_legacy`)
      .then(resp => resp.data)
  },

  fetchPaginatedMainBrokenLinks: function(page) {
    return axios.get(`${API_BASE}/broken_links?page=${page}`)
      .then(resp => resp.data)
  },

  update: function(id, params) {
    return axios.put(`${API_BASE}/broken_links/${id}`, params)
      .then(resp => resp.data)
  },

  redirect: function(id, params) {
    return axios.post(`${API_BASE}/redirects/${id}`, params, { catchErrors: false })
      .then(resp => resp.data)
  },

  updateRedirect: function(id, target) {
    return axios.put(`${API_BASE}/redirects/${id}`, { target }, { catchErrors: false })
      .then(resp => resp.data)
  },

  fetchRedirects: function() {
    return axios.get(`${API_BASE}/redirects`)
      .then(resp => resp.data)
  },

  fetchFreeBrokenLinkStatus: function() {
    return axios.get(`${API_BASE}/broken_links/free_status`)
      .then(resp => resp.data)
  },

  installFreeSnippet: function() {
    return axios.post(`${API_BASE}/broken_links/free_install`)
      .then(resp => resp.data)    
  },

  // refresh: function() {
  //   return axios.put(`${API_BASE}/broken_links/refresh`)
  //     .then(() => { return {} })
  // },
}

export default NotFoundCheckDetailSource



// WEBPACK FOOTER //
// ./app/sources/NotFoundCheckDetailSource.js